<template>
  <footer :class="[isMobile ? 'mobile' : '']">
    <div class="links-container">
      <a :href="`tel:${phone}`">{{ phone }}</a>
      <a target="_blank" rel="noreferrer" :href="`https://www.${linkedInUrl}`">linkedin</a>
    </div>
    <div class="links-container">
      <a :href="`mailTo:${email}`">{{ email }}</a>
      <a target="_blank" rel="noreferrer" href="/static/CV - Josef Doskar.pdf">cv</a>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { contactData } from '@/api/contactApi'
import breakpointsStore from '@/store/breakpoints'

export default defineComponent({
  name: 'FooterNav',

  setup() {
    return {
      isMobile: breakpointsStore.isMobile,
      phone: contactData.phone,
      email: contactData.email,
      linkedInUrl: contactData.linkedInUrl
    }
  }
})
</script>

<style scoped>
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: var(--footer-height);

  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  z-index: 1;

  background: #000;
  border-top: 2px solid var(--building-color);
}
footer.mobile {
  top: 0;
  bottom: unset;

  border-top: none;
  border-bottom: 2px solid var(--building-color);
}
.links-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
a {
  margin: 10px;
  font-size: 1.2rem;
}

@media only screen and (max-width: 400px) {
  a {
    font-size: 1rem;
  }
}
</style>
